import { makeStyles } from '@material-ui/styles';

export default makeStyles((theme) => ({
    root: (props) => ({
        width: [props.size, '!important'],
        height: [props.size, '!important'],
        fontSize: theme.typography.pxToRem(props.size),
    }),
}));
